const BLOCKED_TAGS = [
  "script",
  "style",
  "iframe",
  "object",
  "embed",
  "form",
  "input",
  "button",
  "select",
  "textarea",
  "link",
  "meta",
];

export const sanitizeHtml = (value = "") => {
  if (typeof value !== "string") return "";

  const documentNode = new DOMParser().parseFromString(value, "text/html");
  documentNode.querySelectorAll(BLOCKED_TAGS.join(",")).forEach((element) => element.remove());

  documentNode.body.querySelectorAll("*").forEach((element) => {
    Array.from(element.attributes).forEach((attribute) => {
      const name = attribute.name.toLowerCase();
      const attributeValue = attribute.value.trim().toLowerCase();
      const protocol = attributeValue.includes(":") ? attributeValue.split(":", 1)[0] : "";
      const hasUnsafeUrl = ["href", "src", "xlink:href"].includes(name)
        && ["javascript", "vbscript", "data"].includes(protocol);

      if (name.startsWith("on") || name === "style" || name === "srcdoc" || hasUnsafeUrl) {
        element.removeAttribute(attribute.name);
      }
    });

    if (element.tagName.toLowerCase() === "a" && element.getAttribute("target") === "_blank") {
      element.setAttribute("rel", "noopener noreferrer");
    }
  });

  return documentNode.body.innerHTML;
};
